import { useEffect, useState } from 'react';

export default function usePagination(
  initialCurrentPageIndex = 1,
  initialRecordCountPerPage = 12,
  searchCriteria
) {
  const [currentPageIndex, setCurrentPageIndex] = useState(!!initialCurrentPageIndex && initialCurrentPageIndex > 0 ? initialCurrentPageIndex : 1);
  const [recordCountPerPage, setRecordCountPerPage] = useState(!!initialRecordCountPerPage && initialRecordCountPerPage > 0 ? initialRecordCountPerPage : 12);

  useEffect(
    () => { setCurrentPageIndex(previousValue => 1); },
    [searchCriteria]
  );

  function previousPage() {
    if (currentPageIndex > 1) {
      setCurrentPageIndex(previousValue => previousValue - 1);
    }
  }

  function nextPage(totalRecordCount) {
    if (!!totalRecordCount && totalRecordCount > 0) {
      let totalPageCount = Math.ceil(totalRecordCount / recordCountPerPage );
      if (currentPageIndex < totalPageCount) {
        setCurrentPageIndex(previousValue => previousValue + 1);
      }
    }
  }

  function updateRecordCountPerPage(newRecordPerPageCount) {
    setRecordCountPerPage(previousValue => newRecordPerPageCount > 0 ? newRecordPerPageCount : 1);
  }

  return {
    currentPageIndex,
    recordCountPerPage,
    previousPage,
    nextPage,
    updateRecordCountPerPage
  }

}

